export const AESTHETIC_PRESETS = [
  {
    id: "sakura_pastel",
    name: "Sakura Pastel",
    tagline: "Soft pinks & creams. Delicate and optimistic.",
    swatches: ["#FFF0F3", "#FFD1DC", "#E48BA6", "#A97C89"],
    gradient: "linear-gradient(135deg, #FFF0F3, #FFE3E9 55%, #F7C6D5)",
    text: "#4A3B42",
  },
  {
    id: "ghibli_meadow",
    name: "Ghibli Meadow",
    tagline: "Soft greens & warm cream. Grounding and peaceful.",
    swatches: ["#EBF2E6", "#C2D5B4", "#7EA36A", "#587649"],
    gradient: "linear-gradient(135deg, #EBF2E6, #DCE8D5 55%, #C9DDBC)",
    text: "#2F3E29",
  },
  {
    id: "dusk_violet",
    name: "Dusk Violet",
    tagline: "Twilight lavender & plum. Cozy and reflective.",
    swatches: ["#EAE5F0", "#B5A8C2", "#8C7B9E", "#665675"],
    gradient: "linear-gradient(135deg, #EAE5F0, #DED5E8 55%, #CFC1DE)",
    text: "#332B3B",
  },
  {
    id: "ink_wash",
    name: "Ink Wash",
    tagline: "Warm off-white & soft charcoal. Sumi-e stillness.",
    swatches: ["#F5F3EE", "#C9C8C3", "#6F7379", "#3B3D40"],
    gradient: "linear-gradient(135deg, #F5F3EE, #EAE7DE 55%, #D6D2C7)",
    text: "#1E2022",
  },
];

export const PRESET_IDS = AESTHETIC_PRESETS.map((p) => p.id);
